import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('alpha-admin-auth');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setCredentials(parsed);
        setIsAuthenticated(true);
      } catch {
        localStorage.removeItem('alpha-admin-auth');
      }
    }
  }, []);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          const url = error.config?.url || '';
          if (url.includes('/admin')) {
            setCredentials(null);
            setIsAuthenticated(false);
            localStorage.removeItem('alpha-admin-auth');
            window.location.href = '/beheer';
          }
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  const login = (username, password) => {
    const creds = { username, password };
    setCredentials(creds);
    setIsAuthenticated(true);
    localStorage.setItem('alpha-admin-auth', JSON.stringify(creds));
  };

  const logout = () => {
    setCredentials(null);
    setIsAuthenticated(false);
    localStorage.removeItem('alpha-admin-auth');
  };

  const getAuthHeader = () => {
    if (!credentials) return {};
    const encoded = btoa(`${credentials.username}:${credentials.password}`);
    return { Authorization: `Basic ${encoded}` };
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, credentials, login, logout, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
